import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const EditSolidMirrored12Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M294 0q-61 0-114 21T86 81t-63 91T0 286q0 47 10 84t28 69 44 62 58 61l424-423q-31-31-59-57t-60-44-67-28-84-10zm420 290L292 712l1003 1001 753 333-348-759-986-997z" />
    </svg>
  ),
  displayName: 'EditSolidMirrored12Icon',
});

export default EditSolidMirrored12Icon;
